import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { RichTextLinkComponent } from '@digital-platform/rs-cms/feature-ptypes';
import { RsCmsServicesModule } from '@digital-platform/rs-cms/services';
import { BreadcrumbsComponent } from '@digital-platform/rs-shared/ui';
import { IconComponent } from '@digital-platform/rs-shared/ui-brand';
import { FacilityContactUsComponent } from './facility-contact-us/facility-contact-us.component';
import { FacilityItemComponent } from './facility-item/facility-item.component';
import { FacilityServicesAvailableComponent } from './facility-services-available/facility-services-available.component';
import { RsFrontendFeatureFacilitiesRoutingModule } from './rs-frontend-feature-facilities-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    RsCmsServicesModule,
    RsFrontendFeatureFacilitiesRoutingModule,
    FacilityItemComponent,
    FacilityContactUsComponent,
    RichTextLinkComponent,
    IconComponent,
    BreadcrumbsComponent,
    FacilityServicesAvailableComponent,
    IconComponent,
    RichTextLinkComponent,
  ],
})
export class RsFrontendFeatureFacilitiesModule {}
